module.exports = __webpack_public_path__ + "img/emoji_32.ceec1e7e.png";